import React from "react";
import { useTranslation } from "react-i18next";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import auditModeIcon from "../../resources/shield-checkmark.svg";
import pulseIcon from "../../resources/pulse-outline-glyph.svg";
import { logFunctions as log } from "../../util/Logging";
import LoyaltyType from "../../util/LoyaltyType";

function AdminScreen(props) {
  log.debug("+AdminScreen(TRACE)");

  const { t } = useTranslation("translation");
  let payloadToServer = {
    cardNumber: "",
    userType: "",
    wallID: "",
  };

  log.debug("-AdminScreen(TRACE)");
  return (
    <div className="Screen">
      <div className="contentContainer">
        <div className="contentTitleTextBox" id="adminScreenTitleLabel">
          <h4>{t("Scanner management")}</h4>
        </div>
        <div className="adminButtonContainer">
          <div
            className="auditModeButton"
            id="auditModeButton"
            onClick={() => {
              props.transitionToUnlockingScreen();
              payloadToServer = {
                cardNumber: props.cardNumber,
                userType: "attendant",
                wallID: localStorage.getItem("wallID"),
              };
              props.unlockWithCredentials(payloadToServer);
            }}
          >
            <img
              id="auditModeIcon"
              src={auditModeIcon}
              alt="auditModeIcon"
              className="adminButtonIcon"
            />
            <p className="adminButtonTitle" id="auditModeTitleLabel">
              {t("Audit Mode")}
            </p>
            <p className="adminButtonDesc" id="auditModeDescLabel">
              {t("Audit mode allows you to check order contents")}
            </p>
          </div>
          {props.userType === LoyaltyType.MANAGER &&
          props.scannerDetailsIsButtonEnabled ? (
            <div
              className="scannerDetailsButton"
              id="scannerDetailsButton"
              onClick={() => {
                props.transitionToScannerDetailsScreen();
              }}
            >
              <img
                id="scannerDetailsIcon"
                src={pulseIcon}
                alt="scannerDetailsIcon"
                className="adminButtonIcon"
              />
              <p className="adminButtonTitle" id="scannerDetailsTitleLabel">
                {t("Scanner Details")}
              </p>
              <p className="adminButtonDesc" id="scannerDetailsDescLabel">
                {t("See status of scanners")}
              </p>
            </div>
          ) : (
            <div></div>
          )}
        </div>
      </div>
      <div className="footerContainer" id="footer">
        <Footer
          transitionToAttractScreen={props.transitionToAttractScreen}
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          state={AppState.ADMIN_SCREEN}
        />
      </div>
    </div>
  );
}

export default AdminScreen;
